import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  public userName = '';
  public password = '';
  public errorMessage = '';

  constructor(private mUserService: UserService, private mRouter: Router) { }

  ngOnDestroy(): void {
    document.body.classList.remove('login-page');
  }

  ngOnInit(): void {
    document.body.classList.add('login-page');
  }

  public login() {
    this.mUserService.login({
      userName: this.userName,
      password: this.password
    }).subscribe({
      next: data => {
        this.mUserService.saveToken(data.token);
        this.mUserService.saveRefreshToken(data.refreshToken);
        this.mUserService.saveUser(data.token);
        this.mRouter.navigate(['/dashboard']);
      },

      error: () => this.errorMessage = 'Не верный логин или пароль'
    });
  }
}
